module.exports = __webpack_public_path__ + "img/button_02.a5217a6e.webp";